import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.7 7.3C23 .8 11.3.3 3.7 6L2.4 7.2A1 1 0 003 9h12v9h-5a1 1 0 000 2h5v9a1 1 0 002 0v-9h5a1 1 0 000-2h-5V9h12a1 1 0 001-.6 1 1 0 00-.3-1.1z"/><path d="M10 22H4v-5a1 1 0 00-2 0v12a1 1 0 002 0v-5h5v5a1 1 0 002 0v-6a1 1 0 00-1-1zM29 16a1 1 0 00-1 1v5h-6a1 1 0 00-1 1v6a1 1 0 002 0v-5h5v5a1 1 0 002 0V17a1 1 0 00-1-1z"/>';
export var PatioSVG = function PatioSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PatioSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PatioSVG);